import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const PageHeader = styled.div`
  ${tw`relative
    w-full
    pt-def
    pb-def
    text-white
    text-center
    bg-terciary500
    mb-abs4`};
`;

export default PageHeader;
